import { render, staticRenderFns } from "./ColorDetails.vue?vue&type=template&id=03175a78"
import script from "./ColorDetails.vue?vue&type=script&lang=ts"
export * from "./ColorDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports